import { createContext, useContext, ReactNode } from 'react'
import { useTheme } from '@/hooks/useTheme'
import type { ThemeContextValue } from '@/types/theme'

const ThemeContext = createContext<ThemeContextValue | undefined>(undefined)

interface ThemeProviderProps {
  children: ReactNode
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const theme = useTheme()

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useThemeContext() {
  const context = useContext(ThemeContext)
  if (context === undefined) {
    throw new Error('useThemeContext must be used within a ThemeProvider')
  }
  return context
}

// Hook to get current property information
export function usePropertyInfo() {
  const { propertyInfo, isCustomTheme } = useThemeContext()
  return { propertyInfo, isCustomTheme }
}

// Hook to get current site name
export function useSiteName() {
  const { siteName, isCustomTheme } = useThemeContext()
  return { siteName, isCustomTheme }
} 